import React from 'react'; 
const Home = () => {
    return (<div> 
        <h1>Welcome To SMP Infrastructure!!</h1></div>);
  };
  
  export default Home;
